import { AfterViewInit, Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { AlarmMask } from '../../../../../shared/models/alarm-mask/alarm-mask';
import { Orderable } from '../../../../../shared/models/base/orderable';
import { initFlowbite } from 'flowbite';
import { NgClass } from '@angular/common';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';

@Component({
  selector: 'app-alarm-mask-content',
  templateUrl: './alarm-mask-content.html',
  styleUrl: './alarm-mask-content.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, AgentActionDirective],
})
export class AlarmMaskContent implements AfterViewInit, OnChanges {
  @Input() public alarmMask?: AlarmMask;

  public textGroupElements: Map<number, boolean> = new Map<number, boolean>();

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['alarmMask']) {
      this.inittextGroupElements();
    }
  }

  public ngAfterViewInit(): void {
    initFlowbite();
  }

  public sortByOrder(a: Orderable, b: Orderable): number {
    return (a.orderId ?? 0) - (b.orderId ?? 0);
  }

  public styleToText(style?: string): string {
    switch (style) {
      case 'Static':
        return 'Regular text:';
      case 'OneOf':
        return 'Max. one of the following messages is displayed:';
      case 'CollectiveAlarm':
        return 'At least one of the following messages is displayed:';
      default:
        return 'unknown';
    }
  }

  public isTextGroupOpen(index: number): boolean {
    return this.textGroupElements.get(index) ?? false;
  }

  public toggleTextGroupElement(index: number): void {
    const current = this.textGroupElements.get(index) ?? false;
    this.textGroupElements.set(index, !current);
  }

  private inittextGroupElements(): void {
    this.textGroupElements.clear();
    this.alarmMask?.textGroups?.forEach((_, index) => {
      this.textGroupElements.set(index, true);
    });
  }
}
